import {useEffect, useRef} from 'react';
import paper from 'paper';
import {START_ZOOM_COEFFICIENT} from "@/constants/editor";


export function usePaperSetup({
                                canvasRef,
                                rulersCanvasRef,
                                backgroundCanvasRef,
                                drawBackgroundCanvas,
                                drawRulers,
                                updateTransformUI,
                                onProjectChange,
                              }) {
  const drawBackgroundCanvasRef = useRef(drawBackgroundCanvas);
  const drawRulersRef = useRef(drawRulers);
  const updateTransformUIRef = useRef(updateTransformUI);
  const onProjectChangeRef = useRef(onProjectChange);

  useEffect(() => {
    drawBackgroundCanvasRef.current = drawBackgroundCanvas;
    drawRulersRef.current = drawRulers;
    updateTransformUIRef.current = updateTransformUI;
    onProjectChangeRef.current = onProjectChange;
  }, [drawBackgroundCanvas, drawRulers, updateTransformUI, onProjectChange]);

  useEffect(() => {
    if (!canvasRef.current) return;

    const updateCanvasDimensions = () => {
      if (!canvasRef.current || !rulersCanvasRef.current || !backgroundCanvasRef.current) return;
      const parent = canvasRef.current.parentElement;
      if (!parent) return;

      const width = parent.clientWidth;
      const height = parent.clientHeight;

      canvasRef.current.width = width;
      canvasRef.current.height = height;

      rulersCanvasRef.current.width = width;
      rulersCanvasRef.current.height = height;

      backgroundCanvasRef.current.width = width;
      backgroundCanvasRef.current.height = height;

      if (paper.view) {
        paper.view.viewSize = new paper.Size(width, height);
        drawBackgroundCanvasRef.current();
        drawRulersRef.current();
        updateTransformUIRef.current();
      }
    };

    paper.setup(canvasRef.current);
    paper.view.zoom = START_ZOOM_COEFFICIENT;
    paper.view.center = new paper.Point(0, 0);

    updateCanvasDimensions();

    try {
      const savedProject = localStorage.getItem('vector_editor_autosave_project');
      if (savedProject) {
        paper.project.clear();
        paper.project.importJSON(savedProject);

        const layers = [...paper.project.layers];
        const names = {};
        layers.forEach(layer => {
          if (layer.name === 'backgroundLayer' || layer.name === 'mainLayer') {
             if (names[layer.name]) {
               layer.remove();
             } else {
               names[layer.name] = true;
               layer.matrix = new paper.Matrix();
               layer.pivot = new paper.Point(0, 0);
               layer.applyMatrix = false;
             }
          }
        });

        ['grid', 'glassArea'].forEach((name) => {
          const legacyItem = paper.project.getItem({name});
          if (legacyItem) legacyItem.remove();
        });
      }
    } catch (error) {
      console.error('Помилка відновлення проекту:', error);
    }
    let bgLayer = paper.project.layers['backgroundLayer'];
    if (!bgLayer) {
      bgLayer = new paper.Layer({name: 'backgroundLayer'});
    }

    let mainLayer = paper.project.layers['mainLayer'];
    if (!mainLayer) {
      mainLayer = new paper.Layer({name: 'mainLayer'});
    }

    bgLayer.matrix = new paper.Matrix();
    mainLayer.matrix = new paper.Matrix();
    bgLayer.pivot = new paper.Point(0, 0);
    mainLayer.pivot = new paper.Point(0, 0);

    bgLayer.applyMatrix = false;
    mainLayer.applyMatrix = false;

    bgLayer.sendToBack();
    mainLayer.activate();

    drawBackgroundCanvasRef.current();
    paper.view.draw();
    paper.view.update();

    onProjectChangeRef.current();

    paper.project.view.onSelectionChanged = () => {
      updateTransformUIRef.current();
      onProjectChangeRef.current();
    };

    window.addEventListener('resize', updateCanvasDimensions);
    return () => {
      window.removeEventListener('resize', updateCanvasDimensions);
    };
  }, [canvasRef, rulersCanvasRef, backgroundCanvasRef]);
}